// The "Jak działa Chariot?" strip is onboarding, not a permanent homepage
// section: once the doctor has any search history it is gone for good, while
// recents and example reports stay (decision 2026-11-03).
export function showHowItWorks(showIntro: boolean, hasHistory: boolean): boolean {
  return showIntro && !hasHistory;
}
